import React, { useState, useRef, useEffect } from 'react';

const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa',
  'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan',
  'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio',
  'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia',
  'Wisconsin', 'Wyoming', 'Puerto Rico'
];

const MultiSelectStates = ({ selectedStates, onChange, error }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleState = (state) => {
    if (selectedStates.includes(state)) {
      onChange(selectedStates.filter(s => s !== state));
    } else {
      onChange([...selectedStates, state]);
    }
  };

  const removeState = (state) => {
    onChange(selectedStates.filter(s => s !== state));
  };

  const filteredStates = US_STATES.filter(state =>
    state.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="multi-select-container" ref={dropdownRef}>
      <div 
        className={`multi-select-input ${error ? 'error' : ''} ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="selected-states">
          {selectedStates.length === 0 ? (
            <span className="placeholder">Selecciona uno o más estados</span>
          ) : (
            <div className="selected-tags">
              {selectedStates.map(state => (
                <span key={state} className="state-tag">
                  {state}
                  <button
                    type="button"
                    className="remove-tag"
                    onClick={(e) => {
                      e.stopPropagation();
                      removeState(state);
                    }}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          )}
        </div>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </div>

      {isOpen && (
        <div className="multi-select-dropdown">
          <div className="search-box">
            <input
              type="text"
              className="search-input"
              placeholder="Buscar estado..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>
          <div className="states-list">
            {filteredStates.length === 0 ? (
              <div className="no-results">No se encontraron estados</div>
            ) : (
              filteredStates.map(state => (
                <div
                  key={state}
                  className={`state-option ${selectedStates.includes(state) ? 'selected' : ''}`}
                  onClick={() => toggleState(state)}
                >
                  <input
                    type="checkbox"
                    checked={selectedStates.includes(state)}
                    onChange={() => {}}
                    className="state-checkbox"
                  />
                  <span className="state-name">{state}</span>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectStates;
